import React from "react";

export type AppLayoutContextValue = {
  isSideNavigationCollapsed: boolean;
  isDetailsPanelCollapsed: boolean;
  setSideNavigationCollapsed: (collapsed: boolean) => void;
  setDetailsPanelCollapsed: (collapsed: boolean) => void;
};

const AppLayoutContext = React.createContext<AppLayoutContextValue>({
  isSideNavigationCollapsed: true,
  isDetailsPanelCollapsed: true,
  setSideNavigationCollapsed: () => {},
  setDetailsPanelCollapsed: () => {},
});

export default AppLayoutContext;
